import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "tw-relative tw-flex tw-h-full tw-flex-col"
}
const _hoisted_2 = { class: "tw-px-4" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-2 tw-pt-3" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-py-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-text-slate-500" }, "No results found!")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-py-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-text-slate-500" }, "No results found!")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-py-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-text-slate-500" }, "No results found!")
], -1)
const _hoisted_8 = {
  "data-testid": "video-library-table-columns",
  class: "tw-flex tw-w-full tw-border-b"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick", "onMouseenter"]
const _hoisted_11 = ["checked", "disabled"]
const _hoisted_12 = {
  key: 1,
  class: "tw-flex tw-h-full tw-w-full tw-items-center tw-gap-2 tw-overflow-visible tw-pr-6"
}
const _hoisted_13 = { class: "tw-flex tw-h-full tw-w-full tw-grow tw-flex-col tw-justify-center tw-overflow-hidden" }
const _hoisted_14 = { class: "tw-line-clamp-3 tw-shrink-0 tw-break-words tw-text-xs" }
const _hoisted_15 = {
  key: 2,
  class: "tw-text-xs"
}
const _hoisted_16 = { class: "tw-text-xs" }
const _hoisted_17 = { "data-testid": "video-library-duplicate-indicator" }
const _hoisted_18 = {
  key: 5,
  class: "tw-text-xs"
}
const _hoisted_19 = {
  key: 6,
  class: "tw-text-xs"
}
const _hoisted_20 = {
  key: 1,
  class: "tw-flex tw-h-full tw-items-center tw-justify-center tw-text-center tw-text-sm tw-text-gray-500"
}
const _hoisted_21 = {
  key: 0,
  class: "tw-border-t"
}

import {
  ListAPIQueryParams,
  listEvents,
  listTagLibrary,
  Tag,
  listSeries,
  listVideoAssetUsage,
  VideoAssetUsage
} from '@goldcast/api/backend';
import logger from '@goldcast/logger';
import throttle from 'lodash.throttle';
import { computed, onMounted, ref, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import {
  deleteVideoAsset,
  getVideoLibraryAssets,
  VideoLibrarySortOrder,
  getValidVLSource,
  type VideoAsset,
  downloadVideoAsset,
  downloadVideoMetaDataForVL,
  EDIT_VIDEO_ERROR_CODES_DESCRIPTION,
  editConfigByVideoId,
  setEditConfigByVideoId,
  getIsVideoAssetEditable,
  validateEditConfigByVideoId
} from '../videoLibraryService';
import VideoLibraryCreatedByFilter from './filters/VideoLibraryCreatedByFilter.vue';
import VideoLibraryItemThumbnail from './VideoLibraryItemThumbnail.vue';
import VideoLibraryRenamePopup from './VideoLibraryRenamePopup.vue';
import VideoLibraryTableItemQuickActions from './VideoLibraryTableItemQuickActions.vue';
import VideoLibraryTableItemUsageHover from './VideoLibraryTableItemUsageHover.vue';
import VideoLibraryTableStatusCell from './VideoLibraryTableStatusCell.vue';
import HLSVideoPreviewDialog from '../HLSVideoPreviewDialog.vue';
import VideoLibraryTablePagination from './VideoLibraryTablePagination.vue';
import VideoLibraryUploadButton from './VideoLibraryUploadButton.vue';
import VideoLibraryUsageDialog from './VideoLibraryUsageDialog.vue';
import { transformVideoAssetSource, VideoUploadContext } from '../utils';

import { gateUploadEditorEntry } from '@/studio/contentLab/uploadReadinessGate';
import WorkspaceSelectFilter from '@/studio/workspace/WorkspaceSelectFilter.vue';
import TablerCopy from '@/studioComponents/Icons/tabler/TablerCopy.vue';
import SortButton from '@/studioComponents/SortButton.vue';
import StudioCheckbox from '@/studioComponents/StudioCheckbox.vue';
import StudioConfirmationDialog from '@/studioComponents/StudioConfirmationDialog.vue';
import StudioEmptyState from '@/studioComponents/StudioEmptyState.vue';
import StudioMultiselect, { MultiselectItem } from '@/studioComponents/StudioMultiselect.vue';
import StudioMultiselectTriggerButton from '@/studioComponents/StudioMultiselectTriggerButton.vue';
import StudioSearchInput from '@/studioComponents/StudioSearchInput.vue';
import StudioSpinner from '@/studioComponents/StudioSpinner.vue';
import TooltipPopup from '@/studioComponents/TooltipPopup.vue';
import { isEURegion } from '@/utils';
import { isCLEUProcessingEnabled } from '@/utils/clFeatureGating';
import { getTimeRangeString } from '@/utils/date';

export type VideoLibraryWorkspaceFilter = {
  id: ListAPIQueryParams['workspace'];
  hidden?: boolean;
};

type UploadFlow = 'legacy' | 'content-lab-federated' | 'content-lab-import';

const TOOLTIP_POSITION_THRESHOLD = 3;

type SortableKey = 'name' | 'created_at';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryTable',
  props: {
    pageSize: { default: 50 },
    currentPage: { default: 1 },
    sortOrder: { default: '-created_at' },
    search: { default: '' },
    selectable: { type: Boolean, default: false },
    maxSelections: { default: Infinity },
    createdBy: {},
    initialSelectedVideoAssets: { default: () => [] },
    sources: {},
    events: {},
    tags: {},
    series: {},
    workspaceFilter: {},
    context: { default: '' }
  },
  emits: ["update:currentPage", "update:sortOrder", "update:search", "update:selectedVideoAssets", "update:sources", "update:createdBy", "update:events", "update:tags", "update:series", "update:workspaceFilter"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;



const store = useStore();
const isLoadingFirstTime = ref(false);
const isLoadingVideoAssets = ref(false);
const videoAssets = ref<VideoAsset[]>([]);
const totalCount = ref(0);
const hoveringVideoId = ref<string | null>(null);
const renamingVideoAsset = ref<VideoAsset | null>(null);
const deletingVideoAsset = ref<VideoAsset | null>(null);
const isDeletingVideoAsset = ref(false);
const hlsPreviewVideoAsset = ref<VideoAsset | null>(null);
const selectedVideoAssets = ref<VideoAsset[]>(props.initialSelectedVideoAssets || []);
const isSourceSelectFilterOpen = ref(false);
const isEventListFilterOpen = ref(false);
const isTagsFilterOpen = ref(false);
const isSeriesFilterOpen = ref(false);
const isFetchingEvents = ref(false);
const isFetchingTags = ref(false);
const isFetchingSeries = ref(false);
const eventSelectionFilterSearchTerm = ref('');
const tagSelectionFilterSearchTerm = ref('');
const seriesSelectionFilterSearchTerm = ref('');
const usageData = ref<VideoAssetUsage[] | null>(null);

const isWorkspaceEnabled = computed(() => store?.getters['org/getIsWorkspaceEnabled']);
const isVideoLibraryClipPublishing = computed(() => store?.getters['org/getCurrentOrg']?.showVideoLibraryClipPublish);
const isSimplifiedUploadEnabled = computed(() => store?.getters['org/getCurrentOrg']?.Use_CL_Simplified_Upload);
const isUseCLUploadsInVLEnabled = computed(
  () => store?.getters['org/getCurrentOrg']?.Use_CL_Uploads_In_VL && !isEURegion()
);
// Same gate as Content Studio's clip-duplication feature: when on, we ask the backend to include
// duplicate recordings in the listing and flag each duplicate row with a copy indicator.
const isClipDuplicationEnabled = computed(() => !!store?.getters['org/getCurrentOrg']?.Use_CL_Clip_Duplication);

const route = useRoute();
const router = useRouter();

const workspaceNameIdMap = computed(() => store?.getters['workspace/getWorkspaceNameIdMap'] || {});

const isVideoPage = computed(() => route.path === '/videos');

const isVideoLibraryOpenedInContentLab = computed(() => route.path.includes('/content'));

const uploadFlow = computed<UploadFlow>(() => {
  if (isEURegion() || !isCLEUProcessingEnabled()) {
    return 'legacy';
  }

  if (
    isUseCLUploadsInVLEnabled.value &&
    ['video-library-page', 'registration-page', 'hub-page'].includes(props.context)
  ) {
    return 'content-lab-federated';
  }

  if (props.context === 'content-lab') {
    return 'content-lab-import';
  }

  return 'legacy';
});

const columns = [
  ...(props.selectable ? [{ key: 'select', label: '', sortable: false }] : []),
  { key: 'name', label: 'Title', sortable: true },
  { key: 'created_at', label: 'Created At', sortable: true },
  { key: 'status', label: 'Status', sortable: false },
  ...(!isEURegion() ? [{ key: 'source', label: 'Source', sortable: false }] : []),
  { key: 'created_by', label: 'Created By', sortable: false },
  ...(isWorkspaceEnabled.value ? [{ key: 'workspace', label: 'Team Workspace', sortable: false }] : []),
  { key: 'actions', label: '', sortable: false }
] as { key: string; label: string; sortable: boolean }[];

const sourceSelectFilterItems = ref<MultiselectItem[]>([
  {
    id: 'EVENT_RECORDING',
    title: 'Event Recording',
    selected: props.sources?.includes('EVENT_RECORDING') || false
  },
  ...(isCLEUProcessingEnabled()
    ? [
        {
          id: 'DIRECT_RECORDING',
          title: 'Recording Studio',
          selected: props.sources?.includes('DIRECT_RECORDING') || false
        }
      ]
    : []),
  ...(isUseCLUploadsInVLEnabled.value && isCLEUProcessingEnabled()
    ? [
        {
          id: 'CL_UPLOAD',
          title: 'Upload',
          selected: props.sources?.includes('CL_UPLOAD') || false
        }
      ]
    : []),
  ...(!isVideoLibraryOpenedInContentLab.value
    ? [
        {
          id: 'UPLOADED',
          title: isUseCLUploadsInVLEnabled.value ? 'Event Asset' : 'Manual Upload',
          selected: props.sources?.includes('UPLOADED') || false
        }
      ]
    : []),
  ...(isVideoLibraryClipPublishing.value && !isVideoLibraryOpenedInContentLab.value && isCLEUProcessingEnabled()
    ? [
        {
          id: 'CLIP',
          title: isUseCLUploadsInVLEnabled.value ? 'Clip' : 'Content Lab Clip',
          selected: props.sources?.includes('CLIP') || false
        }
      ]
    : [])
]);

const selectedCreatedByIds = ref<string[]>(props.createdBy);
const eventListFilterItems = ref<MultiselectItem[]>([]);
const tagsFilterItems = ref<MultiselectItem[]>([]);
const seriesFilterItems = ref<MultiselectItem[]>([]);

const selectedSourceNames = computed(() => {
  return sourceSelectFilterItems.value.filter(item => item.selected).map(item => item.title);
});

const selectedEventNames = computed(() => {
  return eventListFilterItems.value.filter(item => item.selected).map(item => item.title);
});

const selectedTagsNames = computed(() => {
  return tagsFilterItems.value.filter(item => item.selected).map(item => item.title);
});

const selectedSeriesNames = computed(() => {
  return seriesFilterItems.value.filter(item => item.selected).map(item => item.title);
});

const isFilterApplied = computed(() => {
  return (
    selectedSourceNames.value.length > 0 ||
    selectedCreatedByIds.value.length > 0 ||
    props.search ||
    selectedEventNames.value.length > 0 ||
    selectedTagsNames.value.length > 0 ||
    selectedSeriesNames.value.length > 0 ||
    props.workspaceFilter
  );
});



__expose({
  selectedVideoAssets
});

const uploadButton = ref<InstanceType<typeof VideoLibraryUploadButton>>();
const isUploadingNewFile = computed(() => uploadButton.value?.isUploadingNewFile);

const selectedVideoIds = computed(() => selectedVideoAssets.value.map(video => video.id));

const isMaxSelectionsReached = computed(() => {
  return selectedVideoAssets.value.length >= props.maxSelections;
});

const getTooltipOpenDirection = (index: number) => {
  if (videoAssets.value.length <= TOOLTIP_POSITION_THRESHOLD) {
    return 'down';
  }

  if (index >= videoAssets.value.length - TOOLTIP_POSITION_THRESHOLD) {
    return 'up';
  }

  return 'down';
};

const scrollableArea = ref<HTMLDivElement | null>(null);

onMounted(() => {
  fetchVideoAssets({
    firstLoad: true,
    currentPage: props.currentPage,
    sortOrder: props.sortOrder,
    search: props.search,
    sources: props.sources,
    events: props.events,
    tags: props.tags,
    series: props.series,
    workspaceFilter: props.workspaceFilter,
    createdBy: props.createdBy
  });
  fetchEventList('');
  fetchTagsList('');
  fetchSeriesList('');
});

const fetchVideoAssets = async ({
  firstLoad,
  currentPage,
  sortOrder,
  search,
  sources,
  createdBy,
  events,
  tags,
  series,
  workspaceFilter
}: {
  firstLoad: boolean;
  currentPage: number;
  sortOrder: VideoLibrarySortOrder;
  search: string;
  sources: ListAPIQueryParams['source'];
  createdBy?: string[];
  events: ListAPIQueryParams['event_ids'][];
  tags: ListAPIQueryParams['event_tag'];
  series: ListAPIQueryParams['series_id'][];
  workspaceFilter?: VideoLibraryWorkspaceFilter;
}) => {
  try {
    if (firstLoad) {
      isLoadingFirstTime.value = true;
    }

    isLoadingVideoAssets.value = true;

    let sourcesForVariant = sources;
    if (isVideoLibraryOpenedInContentLab.value) {
      // Note: When showing VL in Content Lab, we must explicitly hide UPLOADED (Legacy Uploads)
      if (!sourcesForVariant?.length) {
        sourcesForVariant = ['CL_UPLOAD', 'EVENT_RECORDING', 'DIRECT_RECORDING'];
      } else {
        sourcesForVariant = sourcesForVariant.filter(
          source => source === 'CL_UPLOAD' || source === 'EVENT_RECORDING' || source === 'DIRECT_RECORDING'
        );
      }
    }

    const response = await getVideoLibraryAssets({
      limit: props.pageSize,
      offset: (currentPage - 1) * props.pageSize,
      search,
      ordering: sortOrder,
      workspace: workspaceFilter?.id,
      source: sourcesForVariant,
      created_by: createdBy as unknown as ListAPIQueryParams['created_by'],
      event_ids: events,
      event_tag: tags,
      series_id: series,
      includeDuplicates: isClipDuplicationEnabled.value
    });

    videoAssets.value = response.assets;

    if (response.totalCount > 0 && videoAssets.value.length === 0 && currentPage > 1) {
      fetchVideoAssets({
        firstLoad: true,
        currentPage: 1,
        sortOrder: props.sortOrder,
        search,
        sources,
        createdBy,
        events,
        tags,
        series,
        workspaceFilter: props.workspaceFilter
      });
      return;
    }

    totalCount.value = response.totalCount;
    const actualCurrentPage =
      currentPage > Math.ceil(totalCount.value / props.pageSize)
        ? Math.ceil(totalCount.value / props.pageSize)
        : currentPage;

    emit('update:currentPage', actualCurrentPage);
  } catch (error: any) {
    store.dispatch('studioToast/triggerToast', {
      mode: 'error',
      msg: error?.message || 'Unable to fetch videos. Please try again.'
    });
  } finally {
    isLoadingFirstTime.value = false;
    isLoadingVideoAssets.value = false;
    scrollableArea.value?.scrollTo?.({ top: 0, left: 0, behavior: 'smooth' });
  }
};

const onFetchVideoAsset = ({ firstLoad, currentPage }: { firstLoad: boolean; currentPage: number }) => {
  fetchVideoAssets({
    firstLoad,
    currentPage,
    sortOrder: props.sortOrder,
    search: props.search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: props.workspaceFilter
  });
};

const fetchEventList = async (searchTerm: string) => {
  isFetchingEvents.value = true;
  const currentOrg = store.getters['org/getCurrentOrg'];
  const events = await listEvents({
    queryParams: {
      organization: currentOrg.id,
      title: searchTerm,
      limit: 25
    }
  });
  isFetchingEvents.value = false;
  if (!events || !events.results) {
    return;
  }
  eventListFilterItems.value = events?.results?.map(event => ({
    id: event.id,
    title: event.title,
    subtitle: getTimeRangeString({
      date1: event.start_time,
      date2: event.end_time,
      timezone: event.timezone
    }),
    selected: props.events.includes(event.id) || false
  }));
};

const fetchTagsList = async (searchTerm: string) => {
  isFetchingTags.value = true;
  const currentOrg = store.getters['org/getCurrentOrg'];
  let tags = (await listTagLibrary({
    queryParams: {
      organization: currentOrg.id
    }
  })) as Tag[];
  if (!tags) {
    return;
  }
  if (searchTerm && searchTerm.length > 0) {
    tags = tags?.filter(tag => tag?.tag_name?.toLowerCase().includes(searchTerm.toLowerCase()));
  }
  tagsFilterItems.value = tags?.map(tag => ({
    id: tag.id,
    title: tag?.tag_name || '',
    selected: props?.tags?.includes(tag.id) || false
  }));
  isFetchingTags.value = false;
};

const fetchSeriesList = async (searchTerm: string) => {
  isFetchingSeries.value = true;
  const currentOrg = store.getters['org/getCurrentOrg'];
  const series = await listSeries({
    queryParams: {
      organization: currentOrg.id,
      name: searchTerm,
      limit: 25
    }
  });
  isFetchingSeries.value = false;
  if (!series || !series.results) {
    return;
  }
  seriesFilterItems.value = series?.results?.map(series => ({
    id: series.id,
    title: series.name || '',
    selected: props.series.includes(series.id) || false
  }));
};

const handleSort = (field: SortableKey, order: 'asc' | 'desc') => {
  const sortMapping = {
    name: { asc: '-name', desc: 'name' },
    created_at: { asc: '-created_at', desc: 'created_at' }
  };

  const newSortOrder = sortMapping[field][order] as VideoLibrarySortOrder;
  emit('update:sortOrder', newSortOrder);
  fetchVideoAssets({
    firstLoad: false,
    currentPage: 1,
    sortOrder: newSortOrder,
    search: props.search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: props.workspaceFilter
  });
};

const clearAllFilters = () => {
  clearMultiselectFilterSelection(sourceSelectFilterItems, 'sources', false);
  clearMultiselectFilterSelection(eventListFilterItems, 'events', false);
  clearMultiselectFilterSelection(tagsFilterItems, 'tags', false);
  clearMultiselectFilterSelection(seriesFilterItems, 'series', false);

  clearCreatedByFilter();

  emit('update:workspaceFilter', { id: undefined });
};

const onUploadSuccess = (newVideoAsset?: VideoAsset) => {
  clearAllFilters();

  if (newVideoAsset) {
    videoAssets.value.unshift(newVideoAsset);
    totalCount.value = totalCount.value + 1;
  }

  fetchVideoAssets({
    firstLoad: false,
    currentPage: 1,
    sortOrder: props.sortOrder,
    search: props.search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: props.workspaceFilter
  });
};

const onRenameSuccess = (newVideoAsset: VideoAsset) => {
  renamingVideoAsset.value = null;
  videoAssets.value = videoAssets.value.map(video => {
    if (video.id === newVideoAsset.id) {
      return newVideoAsset;
    }
    return video;
  });
};

const onTriggerDownload = (videoAsset: VideoAsset) => {
  downloadVideoAsset(videoAsset);
};

const handleDeleteVideoAsset = () => {
  if (!deletingVideoAsset.value) {
    return;
  }

  const videoIdToDelete = deletingVideoAsset.value.id;
  isDeletingVideoAsset.value = true;

  deleteVideoAsset(videoIdToDelete)
    .then(() => {
      store.dispatch('studioToast/triggerToast', {
        mode: 'success',
        msg: 'Video deleted successfully.'
      });
      document.dispatchEvent(new CustomEvent('ReloadCLHomepageMediaContent'));
      videoAssets.value = videoAssets.value.filter(video => video.id !== videoIdToDelete);
      totalCount.value = totalCount.value - 1;
      delete editConfigByVideoId[videoIdToDelete];
    })
    .catch((errorMessage: string) => {
      store.dispatch('studioToast/triggerToast', { mode: 'error', msg: errorMessage });
    })
    .finally(() => {
      isDeletingVideoAsset.value = false;
      deletingVideoAsset.value = null;
    });
};

const onClickVideoAssetRow = (video: VideoAsset, event?: MouseEvent) => {
  if (isVideoLibraryOpenedInContentLab.value || isVideoPage.value) {
    onTriggerEdit(video, event);
    return;
  }

  handleSelectVideoAsset(video);
};

const handleSelectVideoAsset = (video: VideoAsset) => {
  if (!video.selectable) {
    return;
  }

  if (isMaxSelectionsReached.value && !selectedVideoIds.value.includes(video.id)) {
    if (props.maxSelections === 1) {
      selectedVideoAssets.value = [video];
      emit('update:selectedVideoAssets', selectedVideoAssets.value);
      return;
    }

    return;
  }

  selectedVideoAssets.value = selectedVideoIds.value.includes(video.id)
    ? selectedVideoAssets.value.filter(v => v.id !== video.id)
    : [...selectedVideoAssets.value, video];
  emit('update:selectedVideoAssets', selectedVideoAssets.value);
};

const throttledSetEditLink = throttle((video: VideoAsset) => {
  if (editConfigByVideoId[video.id]) {
    validateEditConfigByVideoId(video);
  } else {
    setEditConfigByVideoId(video);
  }
}, 500);

const onMouseEnterVideoAssetRow = (video: VideoAsset) => {
  hoveringVideoId.value = video.id;

  if (!getIsVideoAssetEditable(video)) {
    return;
  }

  throttledSetEditLink(video);
};

const openEditLink = async (videoAsset: VideoAsset, event?: MouseEvent) => {
  const editConfig = editConfigByVideoId[videoAsset.id];

  if (editConfig.errorCode) {
    const errorMessage =
      EDIT_VIDEO_ERROR_CODES_DESCRIPTION[editConfig.errorCode] || EDIT_VIDEO_ERROR_CODES_DESCRIPTION['UNKNOWN_ERROR'];
    store.dispatch('studioToast/triggerToast', {
      mode: 'error',
      msg: errorMessage
    });
    return;
  }

  if (!editConfig.url) {
    await setEditConfigByVideoId(videoAsset);
    openEditLink(videoAsset, event);
    return;
  }

  const isModifierKeyPressed = event && (event.metaKey || event.ctrlKey);

  // The URL used for navigation. Defaults to the transcode-based edit URL; the readiness gate may
  // override it to the editor route below (see EDITOR_READY).
  let editorUrl = editConfig.url;

  // Universal click→API gate (spec §4.2): for simplified-upload orgs, an in-place open first
  // confirms the editor is ready. If it isn't, the shell readiness popup shows the current status;
  // if the check errors, we toast rather than open a not-ready editor (the new flow has no legacy
  // /import fallback). New-tab (modifier) opens are left untouched.
  // Scope: uploads only (`CL_UPLOAD`). Recordings and clips have no `upload_editor_status`, so
  // gating them would wrongly withhold the editor and fire a pointless media-content read.
  if (
    isSimplifiedUploadEnabled.value &&
    videoAsset.source === 'CL_UPLOAD' &&
    !isModifierKeyPressed &&
    editConfig.contentId
  ) {
    const outcome = await gateUploadEditorEntry({
      contentId: editConfig.contentId,
      projectId: editConfig.projectId,
      title: videoAsset.name
    });
    if (outcome === 'CHECK_FAILED') {
      store.dispatch('studioToast/triggerToast', {
        mode: 'error',
        msg: "Couldn't check if this upload is ready to edit. Please try again."
      });
      return;
    }
    if (outcome === 'NOT_READY') {
      // Inside the CL Video Library modal, close it so the shell readiness popup (already dispatched
      // by the gate) is visible instead of sitting behind the modal — mirrors how EDITOR_READY's
      // editVideoAssetInContentLab closes the dialog when it opens the editor.
      if (props.context === 'content-lab') {
        store.dispatch('contentStudio/toggleVideoLibraryDialog', false);
      }
      return;
    }
    if (outcome === 'EDITOR_READY') {
      // Definitive DONE: enter the editor even if the transcode-based edit URL still points at the
      // legacy /import page (transcript can be ready before HLS finishes; §4a partial readiness).
      editorUrl = `/content/${editConfig.projectId}/${editConfig.contentId}/recordings`;
    }
    // OPEN_LEGACY: keep editConfig.url (existing routing, incl. /import) for backward compatibility.
  }

  if (isVideoLibraryOpenedInContentLab.value && !isModifierKeyPressed) {
    store.dispatch('contentStudio/editVideoAssetInContentLab', {
      contentId: editConfig.contentId,
      projectId: editConfig.projectId,
      url: editorUrl
    });
    return;
  }

  if (isVideoPage.value && !isModifierKeyPressed) {
    router.push(editorUrl);
    return;
  }

  // Open in new tab if modifier key is pressed or if not in special contexts
  window.open(`${window.location.origin}${editorUrl}`, '_blank');
};

const onTriggerEdit = async (videoAsset: VideoAsset, event?: MouseEvent) => {
  if (!getIsVideoAssetEditable(videoAsset)) {
    return;
  }

  if (editConfigByVideoId[videoAsset.id]) {
    openEditLink(videoAsset, event);
    return;
  }

  await setEditConfigByVideoId(videoAsset);

  openEditLink(videoAsset, event);
};

const handleEventListSearch = (search: string) => {
  eventSelectionFilterSearchTerm.value = search;
  fetchEventList(search);
};

const handleTagsSearch = (search: string) => {
  tagSelectionFilterSearchTerm.value = search;
  fetchTagsList(search);
};

const handleSeriesSearch = (search: string) => {
  seriesSelectionFilterSearchTerm.value = search;
  fetchSeriesList(search);
};

const onSearch = (search: string) => {
  emit('update:search', search);

  fetchVideoAssets({
    firstLoad: false,
    currentPage: 1,
    sortOrder: props.sortOrder,
    search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: props.workspaceFilter
  });
};

const handleMultiselectFilterSelection = (
  filterItems: Ref<MultiselectItem[]>,
  emitKey: 'sources' | 'events' | 'tags' | 'series'
) => {
  return itemId => {
    filterItems.value = filterItems.value.map(item => ({
      ...item,
      selected: item.id === itemId ? !item.selected : item.selected
    }));

    if (filterItems.value.every(item => !item.selected)) {
      clearMultiselectFilterSelection(filterItems, emitKey);
      return;
    }

    const updatedFilter = filterItems.value.filter(item => item.selected).map(item => item.id);

    if (emitKey === 'sources') {
      emit('update:sources', updatedFilter as ListAPIQueryParams['source']);
    }
    if (emitKey === 'events') {
      emit('update:events', updatedFilter as unknown as ListAPIQueryParams['event_ids']);
    } else if (emitKey === 'tags') {
      emit('update:tags', updatedFilter as ListAPIQueryParams['event_tag']);
    } else if (emitKey === 'series') {
      emit('update:series', updatedFilter as unknown as ListAPIQueryParams['series_id']);
    }

    fetchVideoAssets({
      firstLoad: false,
      currentPage: 1,
      sortOrder: props.sortOrder,
      search: props.search,
      ...getUpdatedMultiselectFilters(),
      workspaceFilter: props.workspaceFilter,
      [emitKey]: updatedFilter
    });
  };
};

const clearMultiselectFilterSelection = (
  filterItems: Ref<MultiselectItem[]>,
  emitKey: 'sources' | 'createdBy' | 'events' | 'tags' | 'series',
  shouldFetchVideoAsset = true
) => {
  filterItems.value = filterItems.value.map(item => ({
    ...item,
    selected: false
  }));

  if (emitKey === 'sources') {
    emit(
      'update:sources',
      isVideoLibraryOpenedInContentLab.value ? getValidVLSource() : ([] as ListAPIQueryParams['source'])
    );
  } else if (emitKey === 'events') {
    emit('update:events', [] as unknown as ListAPIQueryParams['event_ids']);
  } else if (emitKey === 'tags') {
    emit('update:tags', [] as ListAPIQueryParams['event_tag']);
  } else if (emitKey === 'series') {
    emit('update:series', [] as unknown as ListAPIQueryParams['series_id']);
  }

  if (!shouldFetchVideoAsset) {
    return;
  }

  fetchVideoAssets({
    firstLoad: false,
    currentPage: 1,
    sortOrder: props.sortOrder,
    search: props.search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: props.workspaceFilter
  });
};

const getUpdatedMultiselectFilters = () => {
  const sources = sourceSelectFilterItems.value
    .filter(item => item.selected)
    .map(item => item.id) as ListAPIQueryParams['source'];

  const createdBy = selectedCreatedByIds.value;

  const events = eventListFilterItems.value
    .filter(item => item.selected)
    .map(item => item.id) as unknown as ListAPIQueryParams['event_ids'][];

  const tags = tagsFilterItems.value
    .filter(item => item.selected)
    .map(item => item.id) as ListAPIQueryParams['event_tag'];

  const series = seriesFilterItems.value
    .filter(item => item.selected)
    .map(item => item.id) as unknown as ListAPIQueryParams['series_id'][];

  return {
    sources: sources && sources?.length > 0 ? sources : getValidVLSource(),
    createdBy,
    events,
    tags,
    series
  };
};

const handleToggleSourceSelection = handleMultiselectFilterSelection(sourceSelectFilterItems, 'sources');

const handleToggleEventSelection = handleMultiselectFilterSelection(eventListFilterItems, 'events');

const handleToggleTagsSelection = handleMultiselectFilterSelection(tagsFilterItems, 'tags');

const handleToggleSeriesSelection = handleMultiselectFilterSelection(seriesFilterItems, 'series');

const handleClearSourceSelection = () => {
  clearMultiselectFilterSelection(sourceSelectFilterItems, 'sources');
};

const handleClearEventSelection = () => {
  clearMultiselectFilterSelection(eventListFilterItems, 'events');
};

const handleClearTagsSelection = () => {
  clearMultiselectFilterSelection(tagsFilterItems, 'tags');
};

const handleClearSeriesSelection = () => {
  clearMultiselectFilterSelection(seriesFilterItems, 'series');
};

const onSelectWorkspaceFilter = (workspaceId: string | undefined) => {
  emit('update:workspaceFilter', { id: workspaceId });

  fetchVideoAssets({
    firstLoad: false,
    currentPage: 1,
    sortOrder: props.sortOrder,
    search: props.search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: { id: workspaceId }
  });
};

const onTriggerDelete = (videoAsset: VideoAsset) => {
  // Premature return if the conditions aren't met
  if (
    !isVideoLibraryClipPublishing.value ||
    (videoAsset.creationType !== 'CLIP' && videoAsset.creationType !== 'UPLOADED')
  ) {
    deletingVideoAsset.value = videoAsset;
    return;
  }

  // If asset usage count is 0, return early
  if (videoAsset.usageCount === 0) {
    deletingVideoAsset.value = videoAsset;
    return;
  }

  // Fetch video asset usage if the conditions are met
  listVideoAssetUsage({ id: videoAsset.id })
    .then(response => {
      usageData.value = response;
    })
    .catch(error => {
      logger.error('Video Library Table: Error fetching video asset usage', error);
    });
};

const clearCreatedByFilter = () => {
  selectedCreatedByIds.value = [];
  emit('update:createdBy', []);
};

const handleCreatedByFilterChange = (userIds: string[]) => {
  selectedCreatedByIds.value = userIds;
  emit('update:createdBy', userIds);

  fetchVideoAssets({
    firstLoad: false,
    currentPage: 1,
    sortOrder: props.sortOrder,
    search: props.search,
    ...getUpdatedMultiselectFilters(),
    workspaceFilter: props.workspaceFilter,
    createdBy: userIds
  });
};

return (_ctx: any,_cache: any) => {
  return (isLoadingFirstTime.value)
    ? (_openBlock(), _createBlock(StudioSpinner, { key: 0 }))
    : (totalCount.value === 0 && !isLoadingFirstTime.value && !isLoadingVideoAssets.value && !isFilterApplied.value)
      ? (_openBlock(), _createBlock(StudioEmptyState, { key: 1 }, {
          title: _withCtx(() => [
            _createTextVNode("No videos found")
          ]),
          content: _withCtx(() => [
            _createTextVNode(" Upload a video to get started. ")
          ]),
          cta: _withCtx(() => [
            _createVNode(VideoLibraryUploadButton, {
              ref_key: "uploadButton",
              ref: uploadButton,
              uploadFlow: uploadFlow.value,
              "onUpload:success": onUploadSuccess
            }, null, 8, ["uploadFlow"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(StudioSearchInput, {
                  searchTerm: _ctx.search,
                  placeholder: "Search by title...",
                  onOnSearch: onSearch
                }, null, 8, ["searchTerm"]),
                (!_unref(isEURegion)())
                  ? (_openBlock(), _createBlock(StudioMultiselect, {
                      key: 0,
                      shouldShowSearchInput: false,
                      isOpen: isSourceSelectFilterOpen.value,
                      multiselectItems: sourceSelectFilterItems.value,
                      onOnToggleSelectItem: _unref(handleToggleSourceSelection),
                      onClose: _cache[1] || (_cache[1] = ($event: any) => (isSourceSelectFilterOpen.value = false))
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(StudioMultiselectTriggerButton, {
                          selectedItemsTitles: selectedSourceNames.value,
                          suffix: { singular: 'Source', plural: 'Sources' },
                          characterLengthThreshold: 60,
                          onOpen: _cache[0] || (_cache[0] = ($event: any) => (isSourceSelectFilterOpen.value = !isSourceSelectFilterOpen.value)),
                          onClear: handleClearSourceSelection
                        }, null, 8, ["selectedItemsTitles"])
                      ]),
                      _: 1
                    }, 8, ["isOpen", "multiselectItems", "onOnToggleSelectItem"]))
                  : _createCommentVNode("", true),
                _createVNode(VideoLibraryCreatedByFilter, {
                  selectedUserIds: selectedCreatedByIds.value,
                  "onUpdate:selectedUserIds": handleCreatedByFilterChange
                }, null, 8, ["selectedUserIds"]),
                _createVNode(StudioMultiselect, {
                  isLoadingData: isFetchingEvents.value,
                  shouldShowSearchInput: "",
                  isOpen: isEventListFilterOpen.value,
                  multiselectItems: eventListFilterItems.value,
                  searchTerm: eventSelectionFilterSearchTerm.value,
                  extraClasses: "!tw-w-[360px]",
                  onOnToggleSelectItem: _unref(handleToggleEventSelection),
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (isEventListFilterOpen.value = false)),
                  onOnSearch: handleEventListSearch
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(StudioMultiselectTriggerButton, {
                      selectedItemsTitles: selectedEventNames.value,
                      suffix: { singular: 'Event', plural: 'Events' },
                      characterLengthThreshold: 60,
                      onOpen: _cache[2] || (_cache[2] = ($event: any) => (isEventListFilterOpen.value = !isEventListFilterOpen.value)),
                      onClear: handleClearEventSelection
                    }, null, 8, ["selectedItemsTitles"])
                  ]),
                  "empty-state": _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["isLoadingData", "isOpen", "multiselectItems", "searchTerm", "onOnToggleSelectItem"]),
                _createVNode(StudioMultiselect, {
                  isLoadingData: isFetchingTags.value,
                  shouldShowSearchInput: "",
                  isOpen: isTagsFilterOpen.value,
                  multiselectItems: tagsFilterItems.value,
                  searchTerm: tagSelectionFilterSearchTerm.value,
                  onOnToggleSelectItem: _unref(handleToggleTagsSelection),
                  onClose: _cache[5] || (_cache[5] = ($event: any) => (isTagsFilterOpen.value = false)),
                  onOnSearch: handleTagsSearch
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(StudioMultiselectTriggerButton, {
                      selectedItemsTitles: selectedTagsNames.value,
                      suffix: { singular: 'Tag', plural: 'Tags' },
                      characterLengthThreshold: 60,
                      onOpen: _cache[4] || (_cache[4] = ($event: any) => (isTagsFilterOpen.value = !isTagsFilterOpen.value)),
                      onClear: handleClearTagsSelection
                    }, null, 8, ["selectedItemsTitles"])
                  ]),
                  "empty-state": _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["isLoadingData", "isOpen", "multiselectItems", "searchTerm", "onOnToggleSelectItem"]),
                _createVNode(StudioMultiselect, {
                  isLoadingData: isFetchingSeries.value,
                  shouldShowSearchInput: "",
                  isOpen: isSeriesFilterOpen.value,
                  multiselectItems: seriesFilterItems.value,
                  searchTerm: seriesSelectionFilterSearchTerm.value,
                  onOnToggleSelectItem: _unref(handleToggleSeriesSelection),
                  onClose: _cache[7] || (_cache[7] = ($event: any) => (isSeriesFilterOpen.value = false)),
                  onOnSearch: handleSeriesSearch
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(StudioMultiselectTriggerButton, {
                      selectedItemsTitles: selectedSeriesNames.value,
                      suffix: { singular: 'Series', plural: 'Series' },
                      characterLengthThreshold: 60,
                      onOpen: _cache[6] || (_cache[6] = ($event: any) => (isSeriesFilterOpen.value = !isSeriesFilterOpen.value)),
                      onClear: handleClearSeriesSelection
                    }, null, 8, ["selectedItemsTitles"])
                  ]),
                  "empty-state": _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["isLoadingData", "isOpen", "multiselectItems", "searchTerm", "onOnToggleSelectItem"]),
                (isWorkspaceEnabled.value && !props.workspaceFilter?.hidden)
                  ? (_openBlock(), _createBlock(WorkspaceSelectFilter, {
                      key: 1,
                      showNoWorkspaceOption: false,
                      dropdownVariant: "outline",
                      selectedWorkspace: props.workspaceFilter?.id,
                      onOnSelectWorkspaceFilter: onSelectWorkspaceFilter
                    }, null, 8, ["selectedWorkspace"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(VideoLibraryUploadButton, {
                ref_key: "uploadButton",
                ref: uploadButton,
                buttonVariant: _ctx.selectable ? 'outline' : 'filled',
                uploadFlow: uploadFlow.value,
                "onUpload:success": onUploadSuccess
              }, null, 8, ["buttonVariant", "uploadFlow"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                return _createElementVNode("div", {
                  key: column.key,
                  class: _normalizeClass({
            'tw-flex tw-items-center tw-px-1 tw-py-2 tw-text-xs tw-font-normal': true,

            // Classes based on column type
            'tw-w-[3%]': column.key === 'select',
            'tw-w-[30%]': column.key === 'name',
            'tw-w-[13%]': column.key === 'created_at',
            'tw-w-[10%]': column.key === 'status',
            'tw-hidden md:tw-flex md:tw-flex-1': column.key === 'source' || column.key === 'created_by',
            'tw-hidden lg:tw-flex lg:tw-flex-1': column.key === 'workspace',
            'tw-flex-1 tw-justify-center': column.key === 'actions',

            // Additional classes
            'tw-gap-2': column.sortable
          })
                }, [
                  _createTextVNode(_toDisplayString(column.label) + " ", 1),
                  (column.sortable)
                    ? (_openBlock(), _createBlock(SortButton, {
                        key: 0,
                        trackingId: `video-library-table-${column.key}-sort-button`,
                        isActive: _ctx.sortOrder === column.key || _ctx.sortOrder === `-${column.key}`,
                        sortOrder: _ctx.sortOrder === `-${column.key}` ? 'asc' : _ctx.sortOrder === column.key ? 'desc' : 'none',
                        onSortBy: ($event: any) => (handleSort(column.key as SortableKey, $event))
                      }, null, 8, ["trackingId", "isActive", "sortOrder", "onSortBy"]))
                    : _createCommentVNode("", true)
                ], 2)
              }), 64))
            ])
          ]),
          _createElementVNode("div", {
            ref_key: "scrollableArea",
            ref: scrollableArea,
            class: "tw-flex-1 tw-overflow-y-auto tw-px-4"
          }, [
            (videoAssets.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoAssets.value, (video, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: video.id,
                      class: _normalizeClass({
            'tw-flex tw-w-full hover:tw-bg-slate-50': true,
            'tw-border-b': index !== videoAssets.value.length - 1,
            'tw-cursor-pointer':
              props.selectable || ((isVideoLibraryOpenedInContentLab.value || isVideoPage.value) && _unref(getIsVideoAssetEditable)(video)),
            '!tw-cursor-default': props.selectable && !video.selectable,
            'tw-pointer-events-none tw-opacity-50': props.selectable && video.status === 'READY_TO_PUBLISH'
          }),
                      "data-testid": "video-library-table-row",
                      onClick: ($event: any) => (onClickVideoAssetRow(video, $event)),
                      onMouseenter: ($event: any) => (onMouseEnterVideoAssetRow(video)),
                      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (hoveringVideoId.value = null))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                        return _createElementVNode("div", {
                          key: column.key,
                          class: _normalizeClass({
              'tw-flex tw-items-center tw-px-1 tw-py-2 tw-text-xs tw-font-normal': true,

              // Classes based on column type
              'tw-w-[3%]': column.key === 'select',
              'tw-w-[30%] tw-gap-2': column.key === 'name',
              'tw-w-[13%]': column.key === 'created_at',
              'tw-w-[10%]': column.key === 'status',
              'tw-hidden md:tw-flex md:tw-flex-1': column.key === 'source' || column.key === 'created_by',
              'tw-hidden lg:tw-flex lg:tw-flex-1': column.key === 'workspace',
              'tw-flex-1 tw-justify-center': column.key === 'actions'
            })
                        }, [
                          (column.key === 'select')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (props.maxSelections > 1)
                                  ? (_openBlock(), _createBlock(StudioCheckbox, {
                                      key: 0,
                                      id: "video-library-table-select-checkbox",
                                      checked: selectedVideoIds.value.includes(video.id),
                                      disabled: (isMaxSelectionsReached.value && !selectedVideoIds.value.includes(video.id)) || !video.selectable
                                    }, null, 8, ["checked", "disabled"]))
                                  : (_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "radio",
                                      "data-testid": "video-library-table-select-radio",
                                      checked: selectedVideoIds.value.includes(video.id),
                                      disabled: !video.selectable,
                                      class: _normalizeClass({
                  'tw-text-deep-orange-500 checked:tw-bg-deep-orange-500 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-deep-orange-500 focus:tw-ring-offset-2': true,
                  'tw-cursor-not-allowed tw-text-slate-300': !video.selectable,
                  'tw-cursor-pointer': video.selectable
                })
                                    }, null, 10, _hoisted_11))
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.key === 'name')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(VideoLibraryItemThumbnail, { videoAsset: video }, null, 8, ["videoAsset"]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(video.name), 1)
                                ]),
                                (video.usageCount > 0 && isUseCLUploadsInVLEnabled.value)
                                  ? (_openBlock(), _createBlock(VideoLibraryTableItemUsageHover, {
                                      key: 0,
                                      videoAsset: video,
                                      tooltipDirection: getTooltipOpenDirection(index)
                                    }, null, 8, ["videoAsset", "tooltipDirection"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (column.key === 'created_at')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(video.createdAt), 1))
                              : (column.key === 'status')
                                ? (_openBlock(), _createBlock(VideoLibraryTableStatusCell, {
                                    key: 3,
                                    videoAsset: video,
                                    tooltipPosition: getTooltipOpenDirection(index) === 'down' ? 'bottom' : 'top'
                                  }, null, 8, ["videoAsset", "tooltipPosition"]))
                                : (column.key === 'source')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(transformVideoAssetSource)(video.source)), 1),
                                      (isClipDuplicationEnabled.value && video.isDuplicate)
                                        ? (_openBlock(), _createBlock(TooltipPopup, {
                                            key: 0,
                                            position: getTooltipOpenDirection(index) === 'down' ? 'bottom' : 'top',
                                            triggerClass: "tw-ml-1 tw-flex tw-shrink-0 tw-cursor-default tw-items-center tw-text-slate-400"
                                          }, {
                                            trigger: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_17, [
                                                _createVNode(TablerCopy, { class: "tw-h-4 tw-w-4" })
                                              ])
                                            ]),
                                            content: _withCtx(() => [
                                              _createTextVNode("This is a duplicate recording")
                                            ]),
                                            _: 2
                                          }, 1032, ["position"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (column.key === 'created_by')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(video?.createdBy), 1))
                                    : (column.key === 'workspace')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(workspaceNameIdMap.value[video?.workspace || '']), 1))
                                      : (column.key === 'actions' && video.status !== 'READY_TO_PUBLISH')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                            (hoveringVideoId.value === video.id)
                                              ? (_openBlock(), _createBlock(VideoLibraryTableItemQuickActions, {
                                                  key: 0,
                                                  videoAsset: video,
                                                  selected: selectedVideoIds.value.includes(video.id),
                                                  openDirection: getTooltipOpenDirection(index) === 'down' ? 'bottom-right' : 'top-right',
                                                  "onTrigger:rename": ($event: any) => (renamingVideoAsset.value = video),
                                                  "onTrigger:preview": ($event: any) => (hlsPreviewVideoAsset.value = video),
                                                  "onTrigger:delete": onTriggerDelete,
                                                  "onTrigger:download": onTriggerDownload,
                                                  "onTrigger:downloadSeoGeo": video => _unref(downloadVideoMetaDataForVL)(video.id, video.name),
                                                  "onTrigger:edit": onTriggerEdit
                                                }, null, 8, ["videoAsset", "selected", "openDirection", "onTrigger:rename", "onTrigger:preview", "onTrigger:downloadSeoGeo"]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                        ], 2)
                      }), 64))
                    ], 42, _hoisted_10))
                  }), 128))
                ]))
              : (!isLoadingVideoAssets.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("p", null, [
                      (_ctx.search)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" No videos found matching \"" + _toDisplayString(_ctx.search) + "\" ", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" No videos found ")
                          ], 64))
                    ])
                  ]))
                : _createCommentVNode("", true)
          ], 512),
          (totalCount.value > _ctx.pageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(VideoLibraryTablePagination, {
                  pageSize: _ctx.pageSize,
                  totalCount: totalCount.value,
                  currentPage: _ctx.currentPage,
                  onFetch: onFetchVideoAsset
                }, null, 8, ["pageSize", "totalCount", "currentPage"])
              ]))
            : _createCommentVNode("", true),
          (isUploadingNewFile.value || isLoadingVideoAssets.value)
            ? (_openBlock(), _createBlock(StudioSpinner, {
                key: 1,
                coverContainer: "",
                overlay: ""
              }))
            : _createCommentVNode("", true),
          (renamingVideoAsset.value)
            ? (_openBlock(), _createBlock(VideoLibraryRenamePopup, {
                key: 2,
                videoAsset: renamingVideoAsset.value,
                onClose: _cache[9] || (_cache[9] = ($event: any) => (renamingVideoAsset.value = null)),
                "onSuccess:rename": onRenameSuccess
              }, null, 8, ["videoAsset"]))
            : _createCommentVNode("", true),
          (deletingVideoAsset.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (deletingVideoAsset.value.creationType === 'CLIP')
                  ? (_openBlock(), _createBlock(StudioConfirmationDialog, {
                      key: 0,
                      type: "error",
                      heading: "Delete clip from Video Library",
                      actionsDisabled: isDeletingVideoAsset.value,
                      message: "This will delete the video only from the Video Library. You can still access the video in Content Lab.",
                      primaryActionTitle: isDeletingVideoAsset.value ? 'Deleting...' : 'Delete',
                      secondaryActionTitle: "Cancel",
                      onPrimaryAction: handleDeleteVideoAsset,
                      onSecondaryAction: _cache[10] || (_cache[10] = ($event: any) => (deletingVideoAsset.value = null))
                    }, null, 8, ["actionsDisabled", "primaryActionTitle"]))
                  : (_openBlock(), _createBlock(StudioConfirmationDialog, {
                      key: 1,
                      type: "error",
                      heading: "Are you sure?",
                      actionsDisabled: isDeletingVideoAsset.value,
                      message: `You are deleting the video <b>${deletingVideoAsset.value.name}</b>. This action cannot be undone.`,
                      primaryActionTitle: isDeletingVideoAsset.value ? 'Deleting...' : 'Delete',
                      secondaryActionTitle: "Cancel",
                      onPrimaryAction: handleDeleteVideoAsset,
                      onSecondaryAction: _cache[11] || (_cache[11] = ($event: any) => (deletingVideoAsset.value = null))
                    }, null, 8, ["actionsDisabled", "message", "primaryActionTitle"]))
              ], 64))
            : _createCommentVNode("", true),
          (hlsPreviewVideoAsset.value)
            ? (_openBlock(), _createBlock(HLSVideoPreviewDialog, {
                key: 4,
                videoAsset: hlsPreviewVideoAsset.value,
                onClose: _cache[12] || (_cache[12] = ($event: any) => (hlsPreviewVideoAsset.value = null))
              }, null, 8, ["videoAsset"]))
            : _createCommentVNode("", true),
          (usageData.value && usageData.value.length)
            ? (_openBlock(), _createBlock(VideoLibraryUsageDialog, {
                key: 5,
                usageData: usageData.value,
                onClose: _cache[13] || (_cache[13] = ($event: any) => (usageData.value = null))
              }, null, 8, ["usageData"]))
            : _createCommentVNode("", true)
        ]))
}
}

})